/**
 * Mi contenido path constants only — do not import from Layout here (circular:
 * Layout → ProfilePage → miContenido → … → Layout).
 */
export const MI_CONTENIDO_ROOT = "/mi-contenido";

/** Short Go links manager (Mi contenido). */

/** Full company collections list (Mi contenido). */
export const MI_CONTENIDO_COLECCIONES = "/mi-contenido/colecciones";

/** Media kits list: on/off and days-after-published per podcast (Mi contenido). */
export const MI_CONTENIDO_MEDIA_KITS = "/mi-contenido/media-kits";

/** Full media kit configuration for one podcast. */
export function miContenidoMediaKitDetailPath(podcastId: string): string {
  return `/mi-contenido/media-kits/${encodeURIComponent(podcastId)}`;
}

export const MIS_PODCASTS_MEDIA_KITS = "/mis-podcasts/media-kits";

export function misPodcastsMediaKitDetailPath(podcastId: string): string {
  return `/mis-podcasts/media-kits/${encodeURIComponent(podcastId)}`;
}

/** Create collection wizard under Mi contenido (same `CreateCollection` as Mis podcasts). */
export const MI_CONTENIDO_CREAR_COLECCION = "/mi-contenido/crear-coleccion";

/** Create collection wizard (Mis podcasts URL). */
export const CREAR_COLECCION = "/mis-podcasts/crear-coleccion";

/** Collection detail (same page as `/mis-podcasts/colecciones/:id`). */
export function miContenidoCollectionDetailPath(collectionId: string): string {
  return `/mi-contenido/colecciones/${collectionId}`;
}

/** After create/edit/delete in `CreateCollection`, land on Mi contenido list or Mis podcasts hub. */
export function postCollectionWizardHomePath(pathname: string): string {
  return pathname.startsWith("/mi-contenido")
    ? MI_CONTENIDO_COLECCIONES
    : "/mis-podcasts";
}

/** After create/edit in `CreateCollection`, land on the saved collection's detail page. */
export function postCollectionWizardDetailPath(
  pathname: string,
  collectionId: string,
): string {
  return pathname.startsWith("/mi-contenido")
    ? miContenidoCollectionDetailPath(collectionId)
    : `/mis-podcasts/colecciones/${collectionId}`;
}
